const CheckBoxSvg = () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5788 3.67085C12.8066 3.89866 12.8066 4.26801 12.5788 4.49581L7.57045 9.50419C6.88703 10.1876 5.77899 10.1876 5.09557 9.50419L3.00386 7.41248C2.77606 7.18467 2.77606 6.81533 3.00386 6.58752C3.23167 6.35972 3.60101 6.35972 3.82882 6.58752L5.92053 8.67923C6.14833 8.90704 6.51768 8.90704 6.74549 8.67923L11.7539 3.67085C11.9817 3.44305 12.351 3.44305 12.5788 3.67085Z"
      fill="white"
    />
  </svg>
);

export default CheckBoxSvg;
